const plugin = require('tailwindcss/plugin')

module.exports = {
  content: [
    './resources/**/*.vue',
    './public/**/*.html',
  ],
  theme: {
    screens: {
      'sm': '640px',
      'md': '768px',
      'lg': '1024px',
      'xl': '1280px',
      '2xl': '1536px',
    },
    extend: {
      colors: {
        primary: {
          'color': '#624498',
          'dark': '#201632',
          100: '#FBFCFE',
          200: '#EFEFFD',
          300: '#DDD7F3',
          400: '#CBC1E7',
          500: '#B9AADB',
          600: '#8767B0',
          700: '#73528E',
          800: '#5C3C76',
          850: '#502F8C',
          900: '#422257',

        },
        gray: {
          'dark': '#3D3D3D',
          'light': '#8C8CA1',
        },
        /* success: {
          DEFAULT: "#31D0AA",
          75: "#46D5B2",
          50: "#98E8D4",
          10: "#EAFAF6",
        },
        warning: {
          DEFAULT: "#F46D26",
          75: "#F78C50",
          50: "#FABD91",
          10: "#FEECE0",
        },
        red: {
          DEFAULT: "#EC3A38",
          75: "#E85B5A",
          50: "#F3A2A1",
          10: "#FDECEC",
        },
        dark: {
          DEFAULT: "#1B1B3C",
          75: "#444457",
          50: "#888891",
          10: "#E4E4E7",
        }, */
      },
      fontSize: {
        md: "18px",
      },
    },
  },
  plugins: [
    plugin(function ({ addBase, theme }) {
      addBase({
        'body': { 'min-height': '100vh', 'background-color': '#FBFCFE', 'position': 'relative' },
      })
    }),
    require("@tailwindcss/forms")({
      strategy: 'class',
    }),
  ],
}